import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  rounds: [],
  isRoundsLoading: false,
}

// getters
export const getters = {
  // eslint-disable-next-line camelcase
  getRoundsByLeagueId: ({ rounds }) => ({ leagueId }) => rounds.filter(({ season: { league_id } }) => league_id === leagueId),
}
// mutations
export const mutations = {
  fetchRoundsStarted(state) {
    state.isRoundsLoading = true
  },
  fetchRoundsSuccess(state, { rounds }) {
    Object.values(rounds).map((round) => {
      const index = state.rounds.findIndex(({ id }) => round.id === id)
      if (index >= 0) {
        Vue.set(state.rounds, index, round)
      } else {
        state.rounds.push(round)
      }
    })
    state.isRoundsLoading = false
  },
  fetchRoundsFailed(state) {
    state.isRoundsLoading = false
  },
}
// actions
export const actions = {
  async fetchRoundsByLeagueId({ commit, getters: { getRoundsByLeagueId } }, { leagueId }) {
    const rounds = getRoundsByLeagueId({ leagueId })
    if (rounds.length) {
      return rounds
    }
    try {
      commit('fetchRoundsStarted')
      const rounds = await axios.get(`league/${leagueId}/expiredRounds`)
      commit('fetchRoundsSuccess', { rounds })
      return rounds
    } catch (e) {
      commit('fetchRoundsFailed')
    }
    return false
  },
}
